import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
import BackgroundVoiceCloning from '@src/assets/images/background-voice-cloning.png';

export const StyledQRDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 453px;
    border-radius: 24px;
  }

  .text-or {
    color: ${COLOR.darkGray};
    font-weight: 400;
    text-transform: lowercase;
    font-size: 14px;
  }
  .box-dialog {
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    align-items: center;
    background: ${COLOR.white};
    padding: 45px;

    .qr-title {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      color: ${COLOR.darkGray};
    }

    .qr-description {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      ul {
        list-style: none;
        padding: 0;
      }
    }

    .box-qr-beta {
      background-color: ${COLOR.paleBlue};
      border-radius: 100px;
      display: flex;
      padding: 8px 12px;
      justify-content: center;
      align-items: center;
      width: 100%;

      .qr-beta-text {
        color: ${COLOR.darkGray};
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 510;
        line-height: 24px;
        letter-spacing: -0.4px;
        a {
          color: ${COLOR.info};
        }
      }
    }

    .box-qr-img {
      padding: 12px;
      border-radius: 16px;
      border: 1px solid ${COLOR.darkV2[16]};

      .qr-img {
        width: 176px;
        height: 176px;
      }
    }

    .qr-note {
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${COLOR.darkV2[64]};
    }

    .expired {
      opacity: 0.3;
    }

    .qr-expired {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${COLOR.functionalRed.default};
    }

    .refresh-button {
      border-radius: 500px;
      padding: 8px 12px !important;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      text-align: center;
      color: ${COLOR.indigo.default};
      text-transform: none;
    }

    .qr-refresh-text {
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px; /* 133.333% */
      color: ${COLOR.darkV2[64]};

      & > b {
        color: ${COLOR.black.default};
      }
    }
  }
`;

export const StyledVoiceCloning = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;

  .loading {
    padding-top: 30%;
  }
`;

export const StyledQRVoiceRecordingDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    border-radius: 24px;
  }

  .box-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .box-voice-qr {
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    width: 355px;
    margin: 48px;

    .qr-title {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      color: ${COLOR.darkBlue};
      text-align: center;
    }

    .box-voice-info {
      display: flex;
      flex-direction: row;
      gap: 12px;
      justify-content: flex-start;
      align-items: center;
      border-radius: 16px;
      background: ${COLOR.darkV2[8]};
      padding: 8px 12px;
      width: 200px;

      .avatar {
        border: 1px solid ${COLOR.darkV2[64]};
        width: 60px;
        height: 60px;
      }

      .box-info-detail {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        .category {
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          word-wrap: break-word;
          color: ${COLOR.black.default};
        }

        .name {
          font-weight: 700;
          font-size: 16px;
          color: ${COLOR.darkBlue};
          word-wrap: break-word;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 132px;
          white-space: nowrap;
        }
      }
    }

    .box-qr {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 16px;
      align-items: center;

      .box-qr-current-sentence {
        background-color: ${COLOR.paleBlue};
        border-radius: 100px;
        display: flex;
        padding: 8px 0px;
        justify-content: center;
        align-items: center;
        width: 100%;
      }

      .qr-current-sentence-text {
        color: ${COLOR.info};
        text-align: center;
        font-family: 'SF Pro Text';
        font-size: 16px;
        font-style: normal;
        font-weight: 510;
        line-height: 24px;
        letter-spacing: -0.4px;
      }

      .box-qr-img {
        padding: 15px;
        border-radius: 16px;
        border: 1px solid ${COLOR.darkV2[16]};
      }

      .qr-note {
        color: ${COLOR.darkV2[64]};
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 510;
        line-height: 24px;
        letter-spacing: -0.4px;
      }
    }
  }
`;

export const StyledFirstVoice = styled('div')`
  background: ${(props) =>
    props.isMobile ? 'unset' : `url(${BackgroundVoiceCloning}) no-repeat`};
  padding: ${(props) => (props.isMobile ? 0 : '40px')};
  border-radius: 8px;
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-size: cover;
  margin: ${(props) => props.isMobile && '0 -10px'};
  min-height: 88vh;

  .voice-cloning-title-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;

    .voice-cloning-title {
      color: ${COLOR.darkGray};
      font-size: ${(props) => (props.isMobile ? '24px' : '48px')};
      font-weight: 700;
      line-height: ${(props) => (props.isMobile ? '32px' : '56px')};
      word-wrap: break-word;
    }

    .voice-cloning-description {
      color: rgba(28, 28, 30, 0.64);
      font-size: ${(props) => (props.isMobile ? '16px' : '20px')};
      font-weight: 400;
      line-height: 28px;
      word-wrap: break-word;
    }
  }

  .voice-cloning-step-container {
    display: flex;
    align-items: center;
    margin: 40px 0;
    text-align: left;

    .step {
      flex: 1;
      padding: 1rem;
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: auto;

      .step-icon {
        margin-bottom: auto;
        max-height: 48px;
        max-width: 48px;
      }

      .step-title {
        color: ${COLOR.darkGray};
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        word-wrap: break-word;
      }

      .step-description {
        color: rgba(60, 60, 67, 0.64);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        word-wrap: break-word;
      }
    }
  }

  .download-app-button {
    padding: 0;
    margin-bottom: 24px;
  }

  .voice-cloning-demo-container {
    width: 80%;
    height: 100%;
    padding: ${(props) => (props.isMobile ? '12px 24px' : '24px')};
    background: white;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
    border-radius: 24px;
    flex-direction: column;
    align-items: center;
    gap: ${(props) => (props.isMobile ? '16px' : '24px')};
    display: inline-flex;
  }

  .voice-cloning-demo {
    display: flex;
    gap: ${(props) => (props.changeDirectionList ? '4px' : '24px')};
    align-items: center;
    width: 100%;
    flex-direction: ${(props) =>
      props.changeDirectionList ? 'column' : 'row'};
  }

  .voice-cloning-demo-wrapper {
    padding: 12px;
    width: 100%;
    height: 100%;
    padding: 12px;
    background: white;
    border-radius: 437.5px;
    border: 1.75px rgba(60, 60, 67, 0.16) solid;
    justify-content: space-between;
    align-items: center;
    gap: ${(props) => (props.isMobile ? '8px' : '16px')};
    display: inline-flex;

    .play-icon {
      color: ${COLOR.darkBlue};
      padding: 4px;
    }

    .pause-icon {
      color: ${COLOR.darkBlue};
      background: ${COLOR.primary};
      padding: 4px;
    }

    .sound-icon {
      font-size: 32px;
    }
  }

  .intro-mobile-web-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    margin-top: -40px;
    margin-bottom: 24px;
  }

  .intro-mobile-web {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    background: rgba(0, 122, 255, 0.1);
    padding: 8px 16px;
    border-radius: 100px;
  }

  .intro-mobile-web-text {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${COLOR.darkGray};
    text-align: left;
  }

  .info-icon {
    color: ${COLOR.blueV2};
    width: 13px;
    height: 13px;
    padding: 0;
  }

  .demo-item {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
  }

  .demo-title {
    display: flex;
    align-items: center;
    gap: ${(props) => (props.isMobile ? '6px' : '8px')};
  }

  .voice-name {
    color: ${COLOR.darkGray};
    font-size: ${(props) => (props.isMobile ? '12px' : '14px')};
    font-weight: 700;
    line-height: 21px;
    word-wrap: break-word;
  }

  .voice-desc {
    color: rgba(28, 28, 30, 0.48);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    word-wrap: break-word;
    text-align: left;
  }

  .original-voice-label {
    height: 100%;
    border-radius: 500px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    display: inline-flex;

    padding: ${(props) => (props.isMobile ? '2px 8px' : '2px 11px')};
    color: ${COLOR.darkBlue};
    font-size: 12px;
    font-weight: 510;
    line-height: 16px;
    word-wrap: break-word;
    background-color: rgba(30, 22, 78, 0.08);
  }

  .clone-voice-label {
    height: 100%;
    border-radius: 500px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    display: inline-flex;

    padding: ${(props) => (props.isMobile ? '2px 8px' : '2px 11px')};
    color: ${COLOR.blueV2};
    font-size: 12px;
    font-weight: 510;
    line-height: 16px;
    word-wrap: break-word;
    background-color: rgba(0, 122, 255, 0.08);
  }

  .button-create-voice {
    background-color: ${COLOR.primary};
    color: ${COLOR.darkBlue};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    word-wrap: break-word;
    padding: 11px 24px;
    border-radius: 8px;
    border: 1px rgba(60, 60, 67, 0.32) solid;
    cursor: pointer;
    width: 250px;
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .button-create-voice-mobile {
    width: 180px;
  }

  .voice-cloning-title-container,
  .voice-cloning-step-container,
  .voice-cloning-demo-container {
    flex-shrink: 0;
  }

  .emtpy-div {
    background: red;
    flex-grow: 1;
  }
`;
